<template>
    <v-autocomplete filled outlined dense label="Auditores" hide-details="auto" :items="db.auditores"
        :item-text="displayText" item-value="uuid" v-model="plantilla.refUuid" return-object @change="submit">
        <template v-slot:selection="{ item }">
            <div class="auditor-option">
                <div>
                    {{ displayText(item) }}
                </div>
                <div class="auditor-uuid">
                    UUID: {{ item.uuid }}
                </div>
            </div>
        </template>
        <template v-slot:item="{ item }">
            <div class="auditor-option">
                <div>
                    {{ displayText(item) }}
                </div>
                <div class="auditor-uuid">
                    UUID: {{ item.uuid }}
                </div>
            </div>
        </template>
        <template v-slot:append-outer class="ma-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="info darken-1" size="30" @click="generate"
                        style="cursor: pointer">mdi-file-download-outline</v-icon>
                </template>
                <span>Genera formato de ejemplo con la entidad seleccionada y descarga el
                    fichero</span>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    props: {
        plantilla: {
            type: Object,
            default: () => ({})
        },


    },
    data: () => ({
        db: {
            auditores: []
        }
    }),
    methods: {
        displayText(item) {
            return `${item.nombreCompleto} (${item.iniciales}) - ${item.empresa.nombre}`
        },
        submit() {
            this.$emit('input', this.plantilla)
        },
        generate() {
            this.$emit('generate')
        },

        async getAuditores() {
            const xhr = await this.$store.dispatch('auditores/list')
            this.db.auditores = xhr
        },

        async init() {
            await this.getAuditores()
        }
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>
.auditor-option {
    line-height: 1.25;
}

.auditor-uuid {
    color: #9e9e9e;
    font-size: 12px;
}
</style>
